






import Vue from 'vue';
import ArrowUp from './icons/ArrowUp.vue';
import Card from './icons/Card.vue';
import Check from './icons/Check.vue';
import ChevronUp from './icons/ChevronUp.vue';
import Close from './icons/Close.vue';
import CodeBar from './icons/CodeBar.vue';
import Delete from './icons/Delete.vue';
import DropDown from './icons/DropDown.vue';
import DropUp from './icons/DropUp.vue';
import Download from './icons/Download.vue';
import Info from './icons/Info.vue';
import Local from './icons/Local.vue';
import Locker from './icons/Locker.vue';
import Location from './icons/Location.vue';
import Menu from './icons/Menu.vue';
import Pix from './icons/Pix.vue';
import PlayArrow from './icons/PlayArrow.vue';
import Replay from './icons/Replay.vue';
import Schedule from './icons/Schedule.vue';
import Search from './icons/Search.vue';
import Secretary from './icons/Secretary.vue';
import Timer from './icons/Timer.vue';
import Upload from './icons/Upload.vue';
import Accessibility from './icons/Accessibility.vue';

interface Icons {
  [name: string]: Vue.Component;
}

const icons: Icons = {
  accessibility: Accessibility,
  arrowUp: ArrowUp,
  card: Card,
  check: Check,
  chevronUp: ChevronUp,
  close: Close,
  codeBar: CodeBar,
  delete: Delete,
  dropdown: DropDown,
  dropup: DropUp,
  download: Download,
  info: Info,
  locker: Locker,
  local: Local,
  location: Location,
  menu: Menu,
  pix: Pix,
  playArrow: PlayArrow,
  replay: Replay,
  schedule: Schedule,
  search: Search,
  secretary: Secretary,
  timer: Timer,
  upload: Upload,
};

interface Data {
  icons: Icons;
}

export default Vue.extend({
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  data(): Data {
    return {
      icons: icons,
    };
  },
  computed: {
    icon(): Vue.Component {
      return this.icons[this.name];
    },
  },
});
